import React from 'react';

function Shape({text1, text2, className, index}) {
  let order = index % 2;
  return (
    <div className={' display-flex flex-column ' + className}>
      <div style={{order: order === 0 ? order : order + 2}} className="hexagon mt-5">{text1}</div>
      <div style={{}} className="hexagon mt-5">{text2}</div>
    </div>
  );
}

export default Shape;

// index % 2 ?
//   <>
//     <div className="hexagon">{text1}</div>
//     <div className="hexagon mt-5">{text2}</div>
//   </> : <>
//     <div className="hexagon">{text2}</div>
//     <div className="hexagon  mt-5">{text1}</div>
//   </>
